import React from 'react';
import { Check } from "lucide-react";

const ShowStages = ({stage,setStage}) => {


  return (
        <div>
            <div className="flex-1 overflow-y-auto ml-2 p1 bg-gradient-to-br from-purple-50 to-gray-90">
                {/* Header with steps */}
                <h1 className="text-2xl  font-semibold text-gray-900 mb-6 ">
                    Create template
                </h1>
                <div className="bg-gradient-to-br from-purple-50 to-gray-90 rounded-lg w-full max-w-6xl">
                <div className="flex items-center space-x-6 mb-2">
                    {/* Set up template */}
                    <div
                    className={`flex items-center space-x-2 pr-1 rounded cursor-pointer transition ${
                        stage > 1
                        ? "hover:bg-gray-100"
                        : stage === 1
                        ? "bg-blue-50 border border-blue-200"
                        : "hover:bg-gray-100"
                    }`}
                    >
                    <div
                        className={`w-5 h-5 rounded-full flex items-center justify-center ${
                        stage > 1
                            ? "bg-green-500"
                            : stage === 1
                            ? "bg-gradient-to-r from-gray-300 to-blue-400"
                            : "bg-gray-300 border-2 border-gray-300"
                        }`}
                    >
                        {stage > 1 ? (
                        <Check className="w-4 h-4 text-white" />
                        ) : stage === 1 ? (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                        ) : null}
                    </div >
                    <span
                        className={`font-medium ${
                        stage > 1
                            ? "text-gray-900"
                            : stage === 1
                            ? "text-blue-600"
                            : "text-gray-400"
                        }`}
                        onClick={()=>{setStage(1)}}
                    >
                        Set up template
                    </span>
                    </div>

                    {/* Edit template */}
                    <div
                    className={`flex items-center space-x-2 pr-1 rounded cursor-pointer transition ${
                        stage > 2
                        ? "hover:bg-gray-100"
                        : stage === 2
                        ? "bg-blue-50 border border-blue-200"
                        : "hover:bg-gray-100"
                    }`}
                    onClick={()=>{setStage(2)}}
                    >
                    <span className="text-3xl text-gray-400 mt-3">· ·</span>
                    <div
                        className={`w-5 h-5 rounded-full flex items-center justify-center ${
                        stage > 2
                            ? "bg-green-500"
                            : stage === 2
                            ? "bg-gradient-to-r from-gray-300 to-blue-400"
                            : "bg-gray-300 border-2 border-gray-300"
                        }`}
                    >
                        {stage > 2 ? (
                        <Check className="w-4 h-4 text-white" />
                        ) : stage === 2 ? (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                        ) : null}
                    </div>
                    <span
                        className={`font-medium ${
                        stage > 2
                            ? "text-gray-900"
                            : stage === 2
                            ? "text-blue-600"
                            : "text-gray-400"
                        }`}
                    >
                        Edit template
                    </span>
                    </div>

                    {/* Submit for Review */}
                    <div
                    className={`flex items-center space-x-2 pr-1 rounded cursor-pointer transition ${
                        stage > 3
                        ? "hover:bg-gray-100"
                        : stage === 3
                        ? "bg-blue-50 border border-blue-200"
                        : "hover:bg-gray-100"
                    }`}
                    >
                    <span className="text-3xl text-gray-400 mt-3">· ·</span>
                    <div
                        className={`w-5 h-5 rounded-full flex items-center justify-center ${
                        stage > 3
                            ? "bg-green-500"
                            : stage === 3
                            ? "bg-gradient-to-r from-gray-300 to-blue-400"
                            : "bg-gray-300 border-2 border-gray-300"
                        }`}
                    >
                        {stage > 3 ? (
                        <Check className="w-4 h-4 text-white" />
                        ) : stage === 3 ? (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                        ) : null}
                    </div>
                    <span
                        className={`font-medium ${
                        stage > 3
                            ? "text-gray-900"
                            : stage === 3
                            ? "text-blue-600"
                            : "text-gray-400"
                        }`}
                    >
                        Submit for Review
                    </span>
                    </div>
                </div>
                </div>
                

            </div>
        </div>
  );
}

export default ShowStages;
